import {gql} from "@apollo/client";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";
import {
    TreatmentHoldSubmitInput,
    TreatmentHoldInput,
} from "../../offer-at-risk/family-init-hold/TreatmentHoldFormModal";
import {toTreatmentHoldSubmitPayload} from "../../offer-at-risk/family-init-hold/treatmentHoldDefaults";


const GRAPHQL_MUTATION = gql`
mutation submitAuthTreatmentHold($input: TreatmentHoldInput) {
    submitAuthTreatmentHold(input: $input) {
        guid
    }
}`;

type AuthTreatmentHoldInput = TreatmentHoldSubmitInput & {
    authorizationGuid: string;
}

export function useAuthTreatmentHold(authorizationGuid: string) {
    const {execute,} = useMutation$<{ input: AuthTreatmentHoldInput }, void>(GRAPHQL_MUTATION);
    const submitTreatmentHold = useCallback(async function (formValues: TreatmentHoldSubmitInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            const payload = toTreatmentHoldSubmitPayload(formValues);
            await execute({
                variables: {
                    input: {
                        ...payload,
                        authorizationGuid,
                    },
                }
            });
            showToast.success(
                'Treatment Hold request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitTreatmentHold
    }
}
